/* eslint-disable no-underscore-dangle */

import { ApolloClient, HttpLink, ApolloLink } from '@apollo/client/core';
import { setContext } from '@apollo/link-context';
import { InMemoryCache } from '@apollo/client/cache';
import possibleTypes from '@/schemas/possibleTypes.json';
import UserService from '@/services/UserService';
import fetch from 'isomorphic-unfetch';
import { createPersistedQueryLink } from 'apollo-link-persisted-queries';

let apolloClient;
let includeNoCacheHeader = false;

export function setIncludeNocacheHeader(include) {
  includeNoCacheHeader = include;
}

export function refreshApolloClient({ restoreCache = true, ssr = false } = {}) {
  const authLink = setContext((_, { headers }) => {
    const newHeaders = { ...headers };
    const sessionid = UserService.getSessionId();
    const customertoken = UserService.getCustomerToken();

    if (sessionid) {
      newHeaders.sessionid = sessionid;
    }

    if (customertoken) {
      newHeaders.customertoken = customertoken;
    }

    if (includeNoCacheHeader) {
      newHeaders.nocache = includeNoCacheHeader;
    }

    return {
      headers: newHeaders,
    };
  });

  const httpLink = new HttpLink({
    uri: process.env.APOLLO_ENDPOINT,
    fetch,
  });

  const cache = new InMemoryCache({
    possibleTypes,
    addTypename: false,
    typePolicies: {
      Query: {
        fields: {
          commonData: {
            merge: true,
          },
        },
      },
      ProductTaxonomyAttributeGroup: {
        fields: {
          attributes: {
            merge(existing = [], incoming = []) {
              return incoming;
            },
          },
        },
      },
    },
  });

  if (restoreCache && !window?.isServer) {
    const state = window.__APOLLO_STATE__;
    if (state) {
      cache.restore(state);
    }
  }

  apolloClient = new ApolloClient({
    link: ApolloLink.from([
      createPersistedQueryLink({
        useGETForHashedQueries: true,
      }),
      authLink,
      httpLink,
    ]),
    cache,
    ...(ssr ? { ssrMode: true } : { ssrForceFetchDelay: 100 }),
  });
}

// eslint-disable-next-line import/prefer-default-export
export function createApolloClient(ssr = false) {
  if (apolloClient) {
    return apolloClient;
  }

  refreshApolloClient({
    restoreCache: true,
    ssr,
  });

  return apolloClient;
}
